import './DownloadButton.css'
import React from 'react'

export default props => {
    return (
        <a className="download-button" href={props.file} target="_blank">
            {props.text}
        </a>
    )
}